export const INITIAL_CONFIG_KEY = "default";
export const DEFAULT_CONFIG_KEY = "defaultConfigKey";
export const SAVED_CONFIG_KEY   = "currentConfigName";
export const SAVED_CREDS_KEY    = "authHeaders";

export const APP_INITIALIZED = 'APP_INITIALIZED';
export const ORGANISATION_FETCHED = 'ORGANISATION_FETCHED';

export const QUOTE_CALCULATED = 'QUOTE_CALCULATED';

export const QUOTES_FETCH_REQUESTED = 'QUOTES_FETCH_REQUESTED';
export const QUOTES_FETCHED = 'QUOTES_FETCHED';
export const QUOTES_FETCH_FAILED = 'QUOTES_FETCH_FAILED';

export const ORG_LOANS_FETCH_REQUESTED = 'ORG_LOANS_FETCH_REQUESTED';
export const ORG_LOANS_FETCHED = 'ORG_LOANS_FETCHED';
export const ORG_LOANS_FETCH_FAILED = 'ORG_LOANS_FETCH_FAILED';

export const LOANS_FETCH_REQUESTED = 'LOANS_FETCH_REQUESTED';
export const LOANS_FETCHED = 'LOANS_FETCHED';
export const LOANS_FETCH_FAILED = 'LOANS_FETCH_FAILED';

export const LOAN_FETCH_REQUESTED = 'LOAN_FETCH_REQUESTED';
export const LOAN_FETCHED = 'LOAN_FETCHED';
export const LOAN_FETCH_FAILED = 'LOAN_FETCH_FAILED';

export const INVESTORS_FETCH_REQUESTED = 'INVESTORS_FETCH_REQUESTED';
export const INVESTORS_FETCHED = 'INVESTORS_FETCHED';
export const INVESTORS_FETCH_FAILED = 'INVESTORS_FETCH_FAILED';

export const INVESTOR_FETCH_REQUESTED = 'INVESTOR_FETCH_REQUESTED';
export const INVESTOR_FETCHED = 'INVESTOR_FETCHED';
export const INVESTOR_FETCH_FAILED = 'INVESTOR_FETCH_FAILED';

export const REFERRALS_FETCH_REQUESTED = 'REFERRALS_FETCH_REQUESTED';
export const REFERRALS_FETCHED = 'REFERRALS_FETCHED';
export const REFERRALS_FETCH_FAILED = 'REFERRALS_FETCH_FAILED';

export const REFERRAL_FETCH_REQUESTED = 'REFERRAL_FETCH_REQUESTED';
export const REFERRAL_FETCHED = 'REFERRAL_FETCHED';
export const REFERRAL_FETCH_FAILED = 'REFERRAL_FETCH_FAILED';

export const APPLICATION_FETCHED = 'APPLICATION_FETCHED';

export const TOGGLE_NOTIFICATION = 'TOGGLE_NOTIFICATION';
export const TOGGLE_SPINNER = 'TOGGLE_SPINNER';

export const XERO_SNAPSHOT_FETCHED = 'XERO_SNAPSHOT_FETCHED';

export const PAYWAY_TRANSACTIONS_FETCH_REQUESTED = 'PAYWAY_TRANSACTIONS_FETCH_REQUESTED';
export const PAYWAY_TRANSACTIONS_FETCHED = 'PAYWAY_TRANSACTIONS_FETCHED';
export const PAYWAY_TRANSACTIONS_FETCH_FAILED = 'PAYWAY_TRANSACTIONS_FETCH_FAILED';



// WEBPACK FOOTER //
// ./src/utils/constants.js